import { axios } from '@/utils/request'

export function dropSxWorkerTypeList () {
  return axios({
    url: `/sxWorkerType/workTypeDropDown`,
    method: 'Get'
  })
}
// 通过考勤小组获取工人类别
export function getWorkerTypeList (groupId) {
  return axios({
    url: `/dailyWorker/getWorkerTypeList/${groupId}`,
    method: 'Get'
  })
}
